import React from "react";
import "../../components/Graphs/graphStyles.scss";
import {
  UniqueURL1stLevelDirLoaded,
  UniqueBrowserOSDevice,
  UniqueURL2ndLevelDirLoaded,
  UniqueURLbookInProOverall,
} from "./traffic.component";

const TrafficSources = () => {
  return (
    <div className=" flex-grow p-3" >
      <UniqueBrowserOSDevice />
      <UniqueURL1stLevelDirLoaded />
      <UniqueURL2ndLevelDirLoaded />
      <UniqueURLbookInProOverall />
    </div>
  );
};

export default TrafficSources;
